import React from "react";
import { close } from "../helper/webview";
import { arr } from "../helper/data";

export default function Thankyou({ type, application }) {
  setTimeout(() => {
    close();
  }, 2000);

  const msg =
    type === "application_status"
      ? "Thank you for providing us those details. Please check your email for your application results."
      : type === "leadership" || type === "multilingual" || "corporate"
      ? arr[Math.floor(Math.random() * arr.length)]
      : "Success, you can go back to the conversation.";

  const thanks =
    application === "former-employee"
      ? "Great, thank you! Let's proceed."
      : msg;

  return (
    <div className="p-2">
      <div
        className="bg-blue-100 border-t-4 border-blue-500 rounded-b text-blue-900 px-4 py-3 shadow-md"
        role="alert"
      >
        <div className="flex items-center">
          <div className="py-1">
            <svg
              className="fill-current h-6 w-6 text-blue-500 mr-4"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z" />
            </svg>
          </div>
          <div>
            <p className="text-sm font-normal text-justify">{thanks}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
